import { Title } from "@angular/platform-browser";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { GetUserProfileResponse, User, UserProfile, UserRelationship, UserRoleType } from "@apiserver-rest/ponder-data-client-base";
import { AuthService } from "@ponder-core/auth/auth.service";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { CollectionPreviewsComponent } from "./profile/collection-previews.component";
import { ProfileDeckPreviewsComponent } from "./profile/deck-previews.component";
import { PreviewItemContextMenuComponet as PreviewItemContextMenuComponent } from "@ponder-shared/previewItem/preview-item-context-menu.component";
import { ProfileAboutSectionComponent } from "./profile/profile-about-section.component";
import { ProfileInfoComponent } from "./profile/profile-info.component";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { Portable404Component } from "@ponder-features/general/404/404portable.component";
import { AfterViewInit, Component, Input } from "@angular/core";

@Component({
    imports: [
        LoadingComponent,
        CollectionPreviewsComponent,
        ProfileDeckPreviewsComponent,
        PreviewItemContextMenuComponent,
        ProfileInfoComponent,
        ProfileAboutSectionComponent,
        Portable404Component
    ],
    templateUrl: "./user.component.html"
})
export class UserComponent implements AfterViewInit {
    @Input() public username!: string;

    public user?: User;
    public profile?: UserProfile;
    public userRole?: UserRoleType;
    public relationship?: UserRelationship;
    public isOwnProfile: boolean = false;
    public isVisible: boolean = true;

    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;

    public constructor(private ponderDataClient: PonderDataClient, private pageTitle: Title, private events: EventBroker, private auth: AuthService) {
    
    }

    public ngOnInit(): void {
        this.pageTitle.setTitle(`Ponder > ${this.username}`);
        
        this.events.ui.toggleSortFilterBarEvent.emit(false);
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.navbarUpdateEvent.emit();
        
        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            if (authSession?.username && (authSession.username == this.username)) {
                this.isOwnProfile = true;
            }
        });
    }

    public ngAfterViewInit(): void {
        this.ponderDataClient
            .userProfileGet(this.username)
            .subscribe({
                next: (response: GetUserProfileResponse) => {
                    if (response.success && response.userProfile) {
                        this.user = response.userProfile.user;
                        this.profile = response.userProfile.profile;
                        this.userRole = response.userProfile?.role;
                        this.relationship = response.relationship;
                        this.isVisible = response.isVisible;
                        this.loadingSuccess = true;
                    }
                }
            })
            .add(() => { this.isLoading = false; });
    }
}